import { Link } from 'react-router';
import { EmptyState } from './EmptyState';

/** Shown where the signed-in role may not open a screen, or the API refused with 403. */
export function Forbidden() {
  return (
    <EmptyState title="Not permitted" action={<Link to="/">Back to the dashboard</Link>}>
      Your role does not allow this. If you need access, ask a super administrator.
    </EmptyState>
  );
}
